import UserProfileRoutes from "./UserProfileRoutes";

export default UserProfileRoutes;